export const url = "https://interviewauto.onrender.com"